import React, { FC } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { Product } from '../../Interfaces/ShopifyInterface'
import { BuilderPage } from './BuilderPage'

const BuilderPageWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Orders</PageTitle>
      <BuilderPage />
    </>
  )
}

export default BuilderPageWrapper
